module.exports = __webpack_public_path__ + "img/connect4logo.50e8e80d.png";